import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { cplatApiV3, CPLAT_API_ROUTES } from '@/api';
import type {
  DiagnosisListItem,
  InitRequest,
} from '@/types/productOptimization';

type InitResponse = {
  code: string;
  message: string;
  data: DiagnosisListItem[];
};

export const useInitOptimization = () => {
  return useMutation<AxiosResponse<InitResponse>, AxiosError, InitRequest>({
    mutationFn: (body) =>
      cplatApiV3.post<InitResponse>(CPLAT_API_ROUTES.productOptimizationInit, body),
  });
};
